<!--
 * @Description: 登录
 * @Author: 山淑兰
 * @Date: 2019-10-11 15:44:40
 * @LastEditTime: 2020-07-10 09:33:41
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="login" ref="box">
		<div class="nav" v-if="navShow">
			<a :href="navhomeUrl" target="_top">首页</a>
			> <a>登录</a>
		</div>
		<Loading v-if="isShow"></Loading>
		<div class="login-container" v-else>
			<div class="login-logo">
				<img :src="meetingInfo.MobileBannerImage" alt />
			</div>
			<div class="login-content">
				<form action>
					<div class="login-main">
						<van-cell-group>
							<van-field v-model="telVal" type="tel" label="手机号" placeholder="请输入手机号码" left-icon="phone-o"
								@input="signIn" @change="reNum" @blur="publicTools.on_blur()" />
							<div class="drag-verify">
								<drag-verify :successFun="handleSuccessFun" :errorFun="handleErrorFun"></drag-verify>
							</div>
							<div class="CAPTCHA-container" v-if="smsCode">
								<van-field v-model="CAPTCHA" center clearable placeholder="请输入短信验证码"
									left-icon="smile-comment-o" @input="signIn" maxlength="4"
									@blur="publicTools.on_blur()"></van-field>
								<van-button slot="button" size="small" type="primary" @click="getCAPTCHA_btnVal"
									native-type="button" v-if="send">{{ getCAPTCHA }}</van-button>
								<van-button slot="button" size="small" type="primary" native-type="button" v-else>
									{{ getCAPTCHA }}</van-button>
							</div>
							<div class="CAPTCHA-container" v-if="voiceCode">
								<van-field v-model="CAPTCHA" center clearable placeholder="请输入语音验证码"
									left-icon="smile-comment-o" @input="signIn" maxlength="4"
									@blur="publicTools.on_blur()"></van-field>
							</div>
							<div class="getcode" @click="voiceCodeFun" v-if="smsCode">
								收不到验证码？试试<span>"语音验证码"</span>
							</div>
							<div class="getcode" @click="smsCodeFun" v-if="voiceCode">
								还要使用<span>"验证码登录"</span>
							</div>
						</van-cell-group>
						<div class="agree">
							<van-checkbox  icon-size="14px"  shape="square" v-model="protocol">同意</van-checkbox>
							<p><span @click="goProtocol">《用户协议》</span>和<span @click="goProtocol">《隐私政策》</span></p>
						</div>
						<div class="login-btn" @click="loginTo" v-if="showSubmit">注册 / 登录</div>
						<div class="login-btn" v-else>登录中...</div>
					</div>
				</form>
			</div>
		</div>
		<Footer style="position: fixed;" :footInfo="this.footInfo"></Footer>
		<Nav v-if="fNavShow"></Nav>
	</div>
</template>
<script>
	import Loading from '@components/Loading.vue'
	import Footer from '@components/Footer.vue'
	import Cookies from 'js-cookie'
	// import wxShare from "../lib/wxShare"
	import publicSignup from '../lib/signUp.js'
	//import dragVerify from 'vue-drag-verify'
	import dragVerify from './dragVerify.vue'
	import Nav from './SignUp/components/navigation.vue'
	export default {
		name: 'login',
		components: {
			Footer,
			Nav,
			Loading,
			dragVerify,
		},
		data() {
			return {
				telVal: '',
				CAPTCHA: '',
				getCAPTCHA: '获取验证码',
				isShow: true,
				data: {
					m: '',
					accesstoken: '',
					toUrl: '',
				},
				tel: false,
				send: true,
				publicTools: {}, //通用publicSignup
				meetingInfo: {}, //会议基本数据
				showSubmit: true,
				submitFlag: false,
				smsCode: true,
				voiceCode: false,
				handlerIcon: "fa fa-angle-double-right",
				successIcon: "fa fa-check",
				background: "#fff",
				progressBarBg: "#3b82f6",
				completedBg: "#3b82f6",
				handlerBg: "#fff",
				text: "请将滑块拖动到右侧完成验证",
				successText: "验证成功",
				width: 300,
				height: 48,
				textSize: "14px",
				circle: 'true',
				navShow: true,
				navhomeUrl: '',
				locationUrl: '',
				verdifyStatus: false,
				protocol: false,
				fNavShow: true,
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},
			}
		},

		created() {
			this.data = this.$route.query
			console.log(this.data)
			this.publicTools = new publicSignup()
			this.checkLoginStatus()
			this.width = document.body.clientWidth * .9
			console.log(this.width)
			this.init()
		},
		mounted() {
			window.onresize = () => {
				return (() => {
					this.width = document.body.clientWidth * .9
				})()
			}
		},
		methods: {
			async init() {
				if (this.$route.path === '/signup/meetingsignup') {
					this.fNavShow = false
				} else {
					this.fNavShow = true
				}
				console.log(this.$route.path)
			},
			// 滑块验证成功回调
			handleSuccessFun() {
				this.verdifyStatus = true
				console.log(this.verdifyStatus)
			},
			// 滑块验证失败回调
			handleErrorFun() {
				this.verdifyStatus = false
			},
			// ==============
			// async init() {
			//   try {
			//     const headRes = await this.$http.csData({
			//       url: encodeURIComponent(window.location.href.replace(location.hash, ''))
			//     });
			//     const _Wx = new wxShare({
			//       opt: headRes
			//     });
			//     let tolink = window.location.href
			//     _Wx.ready().then(wx => {
			//       _Wx.share(title, desc, link, imgUrl)
			//       console.log(wx)
			//     })
			//   } catch (err) {
			//     console.log(err);
			//   }
			// },
			//检查是否登录
			async checkLoginStatus() {
				let _params = {
					m: this.data.m,
				}
				let _Res = await this.$http.CheckMeetingUserSign(_params)
				if (_Res.Code === 6001 || _Res.Code === 1000) {
					this.getmeetingInfo()
				}
			},
			//正则匹配11位手机号
			reNum() {
				let telVal = this.telVal

				let re = /^1[1-9]\d{9}$/
				let reTel = re.test(telVal)
				if (reTel === false) {
					this.$notify({
						message: '请输入正确的手机号!',
						type: 'danger',
					})
					document.querySelector('.van-field__control').focus()
				} else {
					this.tel = true
				}
			},
			// 当两个输入框都有值时，登录按钮颜色改变，并可以点击登录
			signIn() {
				this.telVal = this.telVal.replace(/[^\d]/g, '')
				let loginBtn = document.querySelector('.login-btn')
				if (
					this.CAPTCHA !== '' &&
					this.telVal !== '' &&
					this.CAPTCHA.length === 4
				) {
					loginBtn.style.opacity = '1'
					this.submitFlag = true
				} else {
					loginBtn.style.opacity = '0.6'
				}
			},
			// 判断是否为微信访问
			isWeiXin() {
				//window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
				var ua = window.navigator.userAgent.toLowerCase()
				//通过正则表达式匹配ua中是否含有MicroMessenger字符串
				if (ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true
				} else {
					return false
				}
			},
			//获取会议基本信息
			async getmeetingInfo() {
				let opt = {
					m: this.data.m,
					ch: this.$route.query.ch,
				}
				this.meetingInfo = await this.publicTools.init(opt, this)
				if (this.meetingInfo.Code === 1000) {
					this.footInfo.LogoTxt = this.meetingInfo.LogoTxt
					this.footInfo.LogoLink = this.meetingInfo.LogoLink
					this.footInfo.LogoImg = this.meetingInfo.LogoImg
					this.isShow = false
					if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
						this.navShow = false
					} else {
						this.navShow = true
						this.navhomeUrl = this.meetingInfo.HomeUrl
					}
				} else {
					this.$notify({
						massage: this.meetingInfo.Msg,
						type: 'danger',
						duration: '3000',
					})
				}
			},
			// 点击获取验证码
			async getCAPTCHA_btnVal() {
				try {
					if (this.telVal && this.tel && this.send == true && this.verdifyStatus) {
						let m = this.data.m
						let _params = {
							m: m,
							phone: this.telVal,
						}
						const Res = await this.$http.verSendMsg(_params)

						if (Res.Code === 1000) {
							this.send = false
							// 开启倒计时
							let _time = 60
							let wstime = setInterval(() => {
								_time--
								this.getCAPTCHA = _time + 's'
								if (_time <= 0) {
									this.getCAPTCHA = '重新发送'
									clearTimeout(wstime)
									this.send = true
								}
							}, 1000)
						} else {
							this.send = true
							this.getCAPTCHA = '重新发送'
							this.$notify({
								message: Res.Msg,
								type: 'danger',
							})
						}
					} else if (!this.telVal || !this.tel || !this.send) {
						this.$notify({
							message: '请输入正确的手机号!',
							type: 'danger',
						})
					} else if (!this.verdifyStatus) {
						this.$notify({
							message: '请将滑块拖动到右侧完成验证!',
							type: 'danger',
						})
					}
				} catch (err) {
					console.log(err)
				}
			},
			smsCodeFun() {
				this.voiceCode = false
				this.smsCode = true
			},
			voiceCodeFun() {
				this.vioceVal()
			},
			async vioceVal() {
				try {
					if (this.telVal && this.tel && this.send == true && this.verdifyStatus) {
						this.voiceCode = true
						this.smsCode = false
						let m = this.data.m
						let _params = {
							m: m,
							phone: this.telVal,
						}
						const Res = await this.$http.verSendVioceMsg(_params)

						if (Res.Code === 1000) {
							this.$notify({
								message: '验证码已发送，请您注意接听陌生号码来电，并记录验证码。',
								type: 'success',
							})
						}
					} else if (!this.telVal || !this.tel || !this.send) {
						this.$notify({
							message: '请输入正确的手机号!',
							type: 'danger',
						})
					} else if (!this.verdifyStatus) {
						this.$notify({
							message: '请将滑块拖动到右侧完成验证!',
							type: 'danger',
						})
					}
				} catch (err) {
					console.log(err)
				}
			},
			goProtocol(){
				window.location.href = 'https://mp.weiqihd.com/msite/site/10351/11134'
			},
			// 登录
			async loginTo() {
				try {
					if (this.telVal && this.CAPTCHA && this.submitFlag == true && this.protocol ) {
						this.showSubmit = false
						let _params = {
							m: this.data.m,
							phone: this.telVal,
							code: this.CAPTCHA,
						}
						const Res = await this.$http.VerMobileReg(_params)
						console.log(Res)
						if (Res.Code === 1000) {
							const {
								accesstoken,
								exp
							} = Res
							// const inFifteenMinutes = new Date(new Date().getTime() + exp * 60 * 1000);
							const inFifteenMinutes = new Date(new Date() * 1 + exp * 1000)

							Cookies.set('wqToken', accesstoken, {
								expires: inFifteenMinutes
							})
							this.showSubmit = true
							if (this.data.toUrl) {
								setTimeout(() => {
									window.location.href = decodeURIComponent(this.data.toUrl)
								}, 0)
							} else {
								this.$router.push({
									path: '/signup/meetingsignup',
									query: this.data,
								})
							}
						} else {
							this.showSubmit = true
							this.submitFlag = false
							this.$notify({
								message: Res.Msg,
								type: 'danger',
							})
						}
					} else if (this.telVal == false || this.telVal.length !== 11) {
						this.reNum()
					} else if (!this.CAPTCHA || this.CAPTCHA.length !== 4) {
						this.$notify({
							message: '请输入正确的验证码!',
							type: 'danger',
						})
					}else if (!this.protocol) {
						this.$notify({
							message: '请同意《用户协议》和《隐私政策》!',
							type: 'danger',
						})
					}
				} catch (err) {
					console.log(err)
				}
			},
		},
	}
</script>
<style lang="scss">
	.van-notify {
		font-size: 28px;
		line-height: 2rem;
	}

	.nav {
		height: 76px;
		font-size: 26px;
		line-height: 76px;
		background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%) url(../assets/home.png) no-repeat 20px center;
		background-size: 30px 30px;
		color: #fff;
		padding: 0 30px 0 60px;

		a {
			color: #fff;
		}
	}

	#login {
		position: relative;
		.login-content {
			padding-bottom: 100px;
			.getcode {
				padding: 0 45px;
				font-size: 26px;
				color: #64748b;

				span {
					color: #3b82f6;
				}
			}

			.login-main {
				.login-btn {
					width: 90%;
					margin: 0 auto;
					margin-top: 1.25rem;
					background: linear-gradient(135deg, #3b82f6, #6366f1);
					height: 3rem;
					font-size: 1.25rem;
					line-height: 3rem;
					border-radius: 12px;
					text-align: center;
					color: #fff;
					opacity: 0.6;
					box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
				}

				.van-hairline--top-bottom::after,
				.van-hairline-unset--top-bottom::after {
					border-width: 0;
				}

				.van-cell:not(:last-child)::after {
					border: 0;
				}

				.van-cell-group {
					background-color: transparent;

					.drag-verify {
						margin: 0 auto;
						margin-bottom: 1.25rem;
						width: 90%;

						.drag_verify {
							width: 80%;
							margin: 0 auto;
						}
					}

					.dv_text {
						width: 100%;
					}

					.van-cell {
						height: 3.4rem;
						font-size: 1rem;
						line-height: 2.8rem;
						width: 90%;
						margin: 0 auto;
						margin-bottom: 1.25rem;
						border-radius: 12px;
						padding: 0.4rem 1rem;
						padding: 0.4rem 0.6rem;
						background: #fff;
						border: 1px solid #e2e8f0;
						box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

						.van-cell__title {
							width: 20%;
						}

						.van-icon {
							font-size: 1.6rem;
							color: #3b82f6;
						}
					}

					.CAPTCHA-container {
						.van-cell__value {
							.van-field__body {
								.van-field__control {
									margin-left: 0.8rem;
								}
							}
						}
					}

					.van-cell--center {
						padding-right: 0.2rem;
					}
				}
			}
		}
	}
</style>
<style scoped lang="scss">
	#login {
		width: 100%;
		height: 100vh;

		.login-container {
			.login-logo {
				>img {
					display: block;
					width: 100%;
				}
			}

			.login-content {
				padding-top: 2.5rem;

				.login-main {
					.CAPTCHA-container {
						display: flex;
						width: 90%;
						margin: 0 auto;
						justify-content: center;

						&>div:first-child {
							flex: 1;
						}

						&>.van-button:last-child {
							width: 200px;
							height: 2.8rem;
							font-size: 0.875rem;
							padding: 0 0.6rem;
							border-radius: 12px;
							margin-top: 0.2rem;
							margin-left: 1.8rem;
							border: 0;
							background: linear-gradient(135deg, #3b82f6, #6366f1);
							box-shadow: 0 2px 8px rgba(59, 130, 246, 0.25);
						}
					}
				}
			}
		}
		.agree{
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-top: 30px;
			font-size: 26px;
			color: #64748b;
			padding: 0 40px;
			label{
				display: flex;
				align-items: center;
			}
			input{
				margin-right: 10px;
				width: 28px;
				height: 28px;
			}
			p{
				span{
					color: #3b82f6;
				}
			}
		}
		// "checkJsApi",
		// "onMenuShareTimeline",
		// "onMenuShareAppMessage",
		// "onMenuShareQQ",
		// "onMenuShareWeibo",
		// "hideMenuItems",
		// "showMenuItems",
		// "hideAllNonBaseMenuItem",
		// "showAllNonBaseMenuItem",
		// "chooseImage",
		// "previewImage",
		// "uploadImage",
		// "downloadImage",
		// "getNetworkType",
		// "openLocation",
		// "getLocation",
		// "hideOptionMenu",
		// "showOptionMenu",
		// "closeWindow",
		// "scanQRCode",
		// "chooseWXPay"
	}
</style>
<style type="text/css">
	body,
	#app {
		background: linear-gradient(135deg, #eef2f7 0%, #f5f7fc 40%, #e8edf5 100%);
	}
</style>
